import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, isRef as _isRef, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fa0dda9e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mb-5" }
const _hoisted_2 = { class: "page-title" }
const _hoisted_3 = { class: "max-w-screen-xl mx-auto" }
const _hoisted_4 = { class: "flex flex-wrap -mx-4" }
const _hoisted_5 = { class: "w-full lg:w-1/4 px-3" }
const _hoisted_6 = { class: "mb-5" }
const _hoisted_7 = { class: "card w-75 shadow-xl" }
const _hoisted_8 = { class: "card-body items-center text-center" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "card-title" }, "Image Web*", -1))
const _hoisted_10 = { class: "mb-5" }
const _hoisted_11 = { class: "card w-75 shadow-xl" }
const _hoisted_12 = { class: "card-body items-center text-center" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "card-title" }, "Image Mobile*", -1))
const _hoisted_14 = { class: "w-full lg:w-3/4 px-4" }
const _hoisted_15 = { class: "card w-full shadow-xl" }
const _hoisted_16 = { class: "card-body" }
const _hoisted_17 = { class: "w-full" }
const _hoisted_18 = {
  key: 0,
  class: "formkit-label"
}
const _hoisted_19 = {
  key: 1,
  class: "formkit-label"
}
const _hoisted_20 = { class: "formkit-label" }
const _hoisted_21 = { class: "formkit-label" }
const _hoisted_22 = { class: "formkit-label" }
const _hoisted_23 = {
  key: 2,
  class: "formkit-label"
}
const _hoisted_24 = { class: "card-actions" }
const _hoisted_25 = { key: 0 }

import {onBeforeMount, ref} from 'vue';
import ApiService from "@/_services/api.service";
import swal from "@/_helpers/swal";
import {useRoute, useRouter} from "vue-router";
import UploadImage from "@/components/forms/UploadImage.vue";
import {IMiddleMenuItem} from "@/models/homepage/IMiddleMenuItem";
import { getItemTypeOptions } from '@/_services/homepage/itemTypeServices.ts'; 

const submitBtnLabel = 'Ajouter';

export default /*#__PURE__*/_defineComponent({
  __name: 'AddMiddleMenuItem',
  setup(__props) {

const title = ref<string>("Ajouter un encart");
const router = useRouter();
const loading = ref<boolean>(false);
const route = useRoute();
const uuidMiddleMenu = ref<string>("");
const form = ref<IMiddleMenuItem>({
    imageWeb: null,
    imageMobile: null
});

const url = route.fullPath;
const regex = /middle-menu-item\/([^\/]+)\/add/;
const match = url.match(regex);
const itemTypeOptions = getItemTypeOptions();
let middleMenu = null;
if (match && match.length > 1) {
    middleMenu = match[1];
}


const filledFieldCount = ref<number>(0);

const blockType = route.params.blockType;
let validationLabel = 'contains_alpha|matches:/^[^/]*$/|length:0,15';
let validationLabelMessageLength = 'Ce champ doit contenir au maximum 15 caractères';
if (blockType === 'travel') {
    validationLabel = 'contains_alpha|matches:/^[^/]*$/|length:0,30';
    validationLabelMessageLength = 'Ce champ doit contenir au maximum 30 caractères';
}

const onSubmit = async (formData) => {
    try {
        filledFieldCount.value = 0;
     
        if (null === form.value.imageWeb || null === form.value.imageMobile) {
            swal.warning('Les deux images sont obligatoires.');
            return false;
        }
        const payload = {
            title: formData.title,
            label: formData.label,
            description: formData.description,
            position: parseInt(formData.position),
            imageWeb: form.value.imageWeb.uuid,
            imageMobile: form.value.imageMobile.uuid,
            itemValue: formData.itemValue,
            middleMenu: formData.middleMenu,
            itemType: parseInt(formData.itemType),
        }
        swal.confirm(`Êtes-vous sûr de vouloir ajouter ?`,
            "Annuler",
            submitBtnLabel
        )
            .then((results) => results.isConfirmed && addMiddleMenuItem(payload))
    } catch (err: any) {
        swal.error(err.errors[0]);
    }
}

onBeforeMount(async () => {
    uuidMiddleMenu.value = route.params.uuid.length ? route.params.uuid as string : "";
});

const addMiddleMenuItem = (data) => {
    ApiService.post('middle_menu_items', data)
        .then(() => {
            loading.value = false;
            swal.info("Ajout avec succès")
                .then((result) => {
                    if (result.isConfirmed) {
                        router.go(-1);
                    }
                });
        })
        .catch((axiosError) => {
            swal.error("Une erreur est survenue lors de l'ajout");
            axiosError.response.data.errors.forEach((error) => {
                if (error.message.startsWith("Item not found for")
                    || error.message.startsWith("Could not convert database value")) {
                    swal.error("Une erreur est survenue au moment de l'ajout, l’uuid ajoutée n’existe pas.");
                    return false;
                }
            });
        });
}

const onCancel = () => {
    swal.confirm(
        "Êtes-vous sûr de vouloir annuler l'ajout ?",
        "Oui",
        "Non"
    ).then((result) => {
        if (result.isDismissed) {
            router.push({
                name: "carouselList"
            });
        }
    });
}

const onImageWebUpload = (image) => {
    form.value.imageWeb = image;
}

const onImageMobileUpload = (image) => {
    form.value.imageMobile = image;
}

const onImageWebRemoved = () => {
    form.value.imageWeb = null;
}

const onImageMobileRemoved = () => {
    form.value.imageMobile = null;
}

const onImageUploadError = (errorMsg: string) => {
    swal.error(errorMsg);
}

function getBaseUrl() {
    return window.location.origin;
}

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", _hoisted_2, _toDisplayString(title.value), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createVNode(UploadImage, {
                  "image-preview-url": getBaseUrl() + '/media/blank2.png',
                  onImageRemoved: onImageWebRemoved,
                  onImageUploaded: onImageWebUpload,
                  onError: onImageUploadError
                }, null, 8, ["image-preview-url"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createVNode(UploadImage, {
                  "image-preview-url": getBaseUrl() + '/media/blank2.png',
                  onImageRemoved: onImageMobileRemoved,
                  onImageUploaded: onImageMobileUpload,
                  onError: onImageUploadError
                }, null, 8, ["image-preview-url"])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_FormKit, {
                  type: "form",
                  actions: false,
                  onSubmit: onSubmit,
                  "outer-class": "w-full",
                  "incomplete-message": "Veuillez remplir tous les champs correctement"
                }, {
                  default: _withCtx(({ state: { valid } }) => [
                    _createVNode(_component_FormKit, {
                      type: "text",
                      name: "title",
                      label: "Titre *",
                      validation: "required|contains_alpha|matches:/^[^/]*$/|length:0,35",
                      "validation-messages": {
                        required: 'Ce champ est obligatoire.',
                        contains_alpha: 'Ce champ doit contenir des lettres..',
                        matches: 'Ce champ ne peut contenir de “/”.',
                        length: 'Ce champ doit contenir au maximum 35 caractères'
                    }
                    }, null, 8, ["validation-messages"]),
                    _createVNode(_component_FormKit, {
                      type: "number",
                      name: "position",
                      label: "Position *",
                      validation: "required|min:1",
                      "validation-messages": {
                        required: 'Ce champ est obligatoire.',
                        min: 'Ce champ doit être un nombre décimal superieur à 0',
                    }
                    }, null, 8, ["validation-messages"]),
                    _createVNode(_component_FormKit, {
                      type: "text",
                      name: "label",
                      label: "Label",
                      validation: _unref(validationLabel),
                      "validation-messages": {
                        required: 'Ce champ est obligatoire.',
                        contains_alpha: 'Ce champ doit contenir des lettres..',
                        matches: 'Ce champ ne peut contenir de “/”.',
                        length: _unref(validationLabelMessageLength)
                    }
                    }, null, 8, ["validation", "validation-messages"]),
                    _createVNode(_component_FormKit, {
                      type: "text",
                      name: "description",
                      label: "Description",
                      validation: "contains_alpha|matches:/^[^/]*$/|length:0,80",
                      "validation-messages": {
                        required: 'Ce champ est obligatoire.',
                        contains_alpha: 'Ce champ doit contenir des lettres..',
                        matches: 'Ce champ ne peut contenir de “/”.',
                        length: 'Ce champ doit contenir au maximum 80 caractères'
                    }
                    }, null, 8, ["validation-messages"]),
                    _createVNode(_component_FormKit, {
                      type: "select",
                      label: "Type *",
                      name: "itemType",
                      modelValue: form.value.itemType,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.itemType) = $event)),
                      options: _unref(itemTypeOptions),
                      validation: "required",
                      "validation-messages": {
                    required: 'Ce champ est obligatoire.'
                }
                    }, null, 8, ["modelValue", "options", "validation-messages"]),
                    (form.value.itemType === '1' || 
                    form.value.itemType === '2' || 
                    form.value.itemType === '5')
                      ? (_openBlock(), _createElementBlock("label", _hoisted_18, " Uuid "))
                      : _createCommentVNode("", true),
                    (form.value.itemType === '4')
                      ? (_openBlock(), _createElementBlock("label", _hoisted_19, "Lien de redirection"))
                      : _createCommentVNode("", true),
                    _withDirectives(_createElementVNode("label", _hoisted_20, "Si lien de redirection type voyage, veuillez vous assurer de mettre un de ces formats: ", 512), [
                      [_vShow, form.value.itemType === '4']
                    ]),
                    _withDirectives(_createElementVNode("label", _hoisted_21, "https://app.club-employes.com/voyage?id=2209{ce_token} : pour être redirigé vers un produit spécifique où 2209 représente l'id de l'offre voyage", 512), [
                      [_vShow, form.value.itemType === '4']
                    ]),
                    _withDirectives(_createElementVNode("label", _hoisted_22, "https://app.club-employes.com/voyage{ce_token} : pour être redirigé vers la page d'accueil de voyage", 512), [
                      [_vShow, form.value.itemType === '4']
                    ]),
                    (form.value.itemType === '3')
                      ? (_openBlock(), _createElementBlock("label", _hoisted_23, "Mot(s) recherché(s)"))
                      : _createCommentVNode("", true),
                    _createVNode(_component_FormKit, {
                      type: "text",
                      name: "itemValue",
                      modelValue: form.value.itemValue,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.itemValue) = $event))
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_FormKit, {
                      type: "hidden",
                      name: "middleMenu",
                      modelValue: _unref(middleMenu),
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(middleMenu) ? (middleMenu).value = $event : middleMenu = $event)),
                      label: "middleMenu"
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_24, [
                      (loading.value === false)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                            _createVNode(_component_FormKit, {
                              type: "submit",
                              label: submitBtnLabel,
                              disabled: !valid,
                              class: _normalizeClass({ 'btn-primary': true, 'btn-block': true })
                            }, null, 8, ["disabled"])
                          ]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_FormKit, {
                        type: "button",
                        label: "Annuler",
                        onClick: onCancel,
                        class: _normalizeClass({ 'btn-secondary': true, 'btn-block': true })
                      })
                    ])
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})